<template>
  <v-row>
    <v-col class="mx-2">
      <Table
        :items="items"
        :headers="headers"
        :openDialog="openDialog"
        @headersUpdated="updateHeadersOperators"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="580px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          :itemsCheckbox="dataCheckboxes"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :showDate="true"
          :showCheck="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import businessUnits from "../../../../store/unidadesDeNegocios/businessUnits";
import Operators from "../../../../models/unidadDeNegocios/operators";
import operators from "../../../../store/operadores/operators";
import date from "@/store/common/date";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      titleTable: this.$tc("businessUnits.businessUnits"),
      title: this.$tc("businessUnits.operators"),
      titleDelete: this.$tc("businessUnits.toOperatorRelation"),
      isLoading: true,
      nameOper: "",
      maxWidth: ["580px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      dataCheckboxes: [
        {
          name: "def",
          label: "Por defecto",
          data: true,
        },
      ],
    };
  },
  computed: {
    headers() {
      return configTable.state.colums.operators;
    },
    items() {
      if (
        !businessUnits.state.edit.operadores ||
        businessUnits.state.edit.operadores.length === 0
      ) {
        return [];
      }
      return businessUnits.state.edit.operadores.map((item) => {
        return Operators.fromJson(item);
      });
    },
    allOperators() {
      return operators.state.operators;
    },
    operatorsSelected() {
      const edit = businessUnits.state.edit.operadores;
      if (!edit || edit.length === 0) {
        return this.allOperators;
      }

      return this.allOperators.filter(
        (model) => !edit.some((selected) => selected.operId == model.id)
      );
    },
    dataSelects() {
      return [
        {
          name: "operId",
          label: "Operadores",
          data: "",
          items: [],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },
    mode: {
      get() {
        return businessUnits.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return businessUnits.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return businessUnits.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  mounted() {
    operators.dispatch("getOperators").then(() => {
      this.isLoading = false;
    });
  },
  methods: {
    async refreshItems() {
      await businessUnits.dispatch(
        "getBusinessUnitsId",
        businessUnits.state.unitId
      );
    },
    updateHeadersOperators(headers) {
      const updatedColums = { ...configTable.state.colums, operators: headers };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    addOperator(form) {
      let payload = form;
      payload.fecDesde = date.state.dateFrom + "T00:00:00.000Z";
      if (date.state.dateTo !== null) {
        payload.fecHasta = date.state.dateTo + "T00:00:00.000Z";
      }
      payload.def = form.def === "true";
      payload.unNegocioId = businessUnits.state.edit.unNegocioId;
      payload.operId = Number(form.operId);
      let operator = operators.state.operators.filter(
        (item) => item.id == payload.operId
      );
      payload.operName = operator[0].name;
      businessUnits.commit("setNew", payload);
      businessUnits
        .dispatch("addBusinessUnitsToOperator")
        .then(() => {
          this.showAlert(
            this.$tc("businessUnits.addOperatorToRelationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
          reject(e);
        });
      this.reset(false);
    },
    editOperator(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.unNegocioId = businessUnits.state.edit.unNegocioId;
        payload.operId = Number(form.operId);
        businessUnits.commit("setEditRelation", payload);
        businessUnits
          .dispatch("editBusinessUnitsToOperator")
          .then(() => {
            this.showAlert(
              this.$tc("businessUnits.editOperatorToRelationSuccess"),
              "#82A1D0"
            );
          })
          .catch((e) => {
            this.showAlert(e.response.data.error.message, "#FF8D58");
            reject(error);
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;
      newItems.def = newItems.def === "true";
      const changes = {};
      const oldItem = this.oldItems;
      if (oldItem) {
        if (oldItem.dateStartInput !== newItems.dateStartInput) {
          changes.dateStartInput = newItems.dateStartInput;
        }

        if (oldItem.dateEndInput !== newItems.dateEndInput) {
          changes.dateEndInput = newItems.dateEndInput;
        }

        if (oldItem.isDefaultBool !== newItems.def) {
          changes.def = newItems.def;
        }
      }

      return changes;
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.operatorsSelected;
          businessUnits.commit(
            "setModeFormRelation",
            this.$tc("operators.addEmployeeToRelation")
          );
          businessUnits.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.dataSelects[0].items = this.allOperators;
          this.oldItems = item;
          await this.setEdit(item);
          businessUnits.commit(
            "setModeFormRelation",
            this.$tc("operators.editBusinessToRelation")
          );
          businessUnits.commit("setOpenFormRelation", true);
          break;
        case "delete":
          businessUnits.commit("setOpenDelete", true);
          this.itemToDelete = {
            operId: item.id,
            unNegocioId: businessUnits.state.edit.unNegocioId,
          };
          break;

        default:
          break;
      }
    },

    setEdit(item) {
      this.dataSelects[0].data = item.id;
      this.dataCheckboxes[0].data = item.isDefaultBool;
      date.state.dateFrom = item.dateStartInput;
      if (item.dateEndInput !== null) {
        date.state.dateTo = item.dateEndInput;
        date.state.checkTo = false;
      } else {
        date.state.checkTo = true;
      }
    },
    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
      date.commit("setCheckTo", null);
    },

    reset(value) {
      this.resetDate();
      businessUnits.commit("setOpenFormRelation", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addOperator(items);
          break;
        case "edit":
          this.editOperator(items);
          break;
        default:
          break;
      }
    },
    deleteItem() {
      businessUnits.commit("setItemDelete", this.itemToDelete);
      businessUnits
        .dispatch("deleteBusinessUnitsToOperator")
        .then(() => {
          this.openDelete = false;
          businessUnits.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("businessUnits.deleteOperatorToRelationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      businessUnits.commit("setOpenDelete", false);
    },
  },
};
</script>
